import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=16b54ccf&scoped=true&"
import script from "./productDetail.vue?vue&type=script&lang=js&"
export * from "./productDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=16b54ccf&prod&lang=scss&"
import style1 from "./productDetail.vue?vue&type=style&index=1&id=16b54ccf&prod&lang=css&"
import style2 from "./productDetail.vue?vue&type=style&index=2&id=16b54ccf&prod&scoped=true&lang=css&"
import style3 from "./productDetail.vue?vue&type=style&index=3&id=16b54ccf&prod&v-show=fromAdmin&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b54ccf",
  null
  
)

export default component.exports